// extracted by mini-css-extract-plugin
export default {"info-box":"info-box__dMRXe","infoBox":"info-box__dMRXe","bold":"bold__fMjqO"};